import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, List, Row, Col, Spin, Image } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { bindActionCreators } from 'redux';
import { queries } from '../../graphql/graphql';
import _s from './index.less';

export const MyPlans = props => {
  const { user } = props;
  const { data = {}, loading, refetch } = useQuery(queries.MAP_USER_RESULTS, {
    variables: { user: user.id }
  });

  useEffect(() => {
    refetch();
  }, [data]);

  const { mapUserResults } = data;

  if (!loading && (!mapUserResults || !mapUserResults.length)) return <div>Plans not found</div>;
  if (loading) return <Spin />;

  const getActions = item => {
    const actions = [
      <Link key={`link-${item.id}`} to={`/plan/${item.plan}/${item.id}`}>
        View
      </Link>
    ];
    return actions;
  };

  return (
    <div style={{ display: 'block', marginTop: '2em' }}>
      <Row>
        <Col span={24}>
          <Card>
            <List
              grid={{ gutter: 16, column: 2, xs: 1, lg: 2, xl: 3, xxl: 4 }}
              dataSource={mapUserResults}
              pagination={{
                onChange: page => {
                  console.log(page);
                },
                pageSize: 10
              }}
              renderItem={item => (
                <List.Item>
                  <Card
                    hoverable
                    cover={<Image alt="" src={item.snapshot} className={_s.image} />}
                    actions={getActions(item)}
                  >
                    <Card.Meta
                      title={(item.planTitle || '').toUpperCase()}
                      description={
                        <>
                          <p>{(item.map && item.map.address) || 'Address is empty'}</p>
                        </>
                      }
                    />
                  </Card>
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

MyPlans.propTypes = {
  user: PropTypes.object.isRequired
};

const connectedMyPlans = connect(mapStateToProps, mapDispatchToProps)(MyPlans);

export default connectedMyPlans;
